module.exports = __webpack_public_path__ + "img/output-onlinegiftools (32).a28be373.gif";